export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3" data-testid="nav-logo">
    <span className="group flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-white p-1 shadow-[0_0_24px_rgba(220,38,38,0.55)] ring-1 ring-brand-red/60 transition-shadow duration-300 hover:shadow-[0_0_38px_rgba(220,38,38,0.8)]">
      <img
        src={`${process.env.PUBLIC_URL}/logo.png`}
        alt="Techworld Business Group logo"
        className="h-full w-full object-contain"
      />
    </span>
    {!compact && (
      <span className="leading-none">
        <span className="block font-display text-xl font-semibold tracking-wide text-white [text-shadow:0_0_18px_rgba(220,38,38,0.4)]">
          TECHWORLD
        </span>
        <span className="mt-1 block font-mono text-[10px] uppercase tracking-[0.3em] text-brand-bright">
          Business Group
        </span>
      </span>
    )}
  </span>
);

export default Logo;
